import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class NewMaintenanceReportStore {
  maintenanceReportStore = [];
  maintenanceService = [];
  innerData = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      maintenanceReportStore: observable,
      innerData: observable,
      loadData: action,
      getServiceData: action,
      loadiInnergridData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    offset,
    limit,
    serviceId,
    fromDate,
    toDate,
  }) {
    console.log("vehicle list");
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      serviceId: serviceId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: 1,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=maintenance&a=newMaintenanceReport",
        "postData=" + base64Input
      );

    this.maintenanceReportStore = response?.data?.data?.maintenancereport;
  }

  async loadiInnergridData(Id) {
    console.log("vehicle list");
    var postData = {
      Id: Id,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=maintenance&a=getNewAdditionalMaintenance",
        "postData=" + base64Input
      );

    this.innerData = response?.data?.data;
  }
  async getServiceData() {
    var postData = "";

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=maintenance&a=getService", "postData=" + base64Input);

    this.maintenanceService = response?.data?.data;
    return response?.data?.data;
  }

  async exportExcel(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=maintenance&a=exportnewmaintenanceexcel&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&colList=" +
      getData.colList +
      "&sid=" +
      getData.sid +
      "&language=" +
      lang;
  }

  async exportpdf(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=maintenance&a=exportnewmaintenancepdf&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&colList=" +
      getData.colList +
      "&sid=" +
      getData.sid +
      "&language=" +
      lang;
  }
}

export default NewMaintenanceReportStore;
